export const UPDATE_CURRENT_LANGUAGE = 'UPDATE_CURRENT_LANGUAGE';

export function updateCurrentLanguage(language) {
  return {
    type: UPDATE_CURRENT_LANGUAGE,
    language,
  };
}
